export enum STORAGE_KEYS {
  APP = 'app',
  PREFERRED_AUTH_METHOD = 'PREFERRED_AUTH_METHOD',
  PREFERRED_DS_AGENT = 'PREFERRED_DS_AGENT',
  STORED_CREDENTIALS = '42a95d25-9fa6-472c-8cf7-a8c35027ecad',
}
